<template>
	<v-menu
		ref="menu"
		v-model="timeMenu"
		:disabled="readonly"
		:close-on-content-click="false"
		:nudge-right="80"
		transition="scale-transition"
		offset-y
		max-width="230px"
		min-width="230px"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-text-field
				v-bind="{ ...$props, ...attrs }"
				readonly
				:value="amPmTime"
				v-on="on"
				@click:clear="$emit('input', '')"
			/>
		</template>
		<v-time-picker
			v-if="timeMenu"
			:value="value"
			full-width
			ampm-in-title
			format="ampm"
			@input="$emit('input', $event)"
		></v-time-picker>
	</v-menu>
</template>

<script>
import parse from "@/utils/parse";
import { DateTime } from "luxon";

export default {
	props: {
		label: String,
		readonly: Boolean,
		clearable: Boolean,
		rules: {
			type: Array,
			default: () => [],
		},
		value: String,
	},

	data() {
		return {
			timeMenu: false,
		};
	},

	computed: {
		amPmTime() {
			const time = parse.time(this.value);
			if (time) return time.toLocaleString(DateTime.TIME_SIMPLE);
			return this.time;
		},
	},
};
</script>
